
import 'survey-core/defaultV2.min.css';
import 'survey-creator-core/survey-creator-core.min.css';
// Creator translations (Editor UI)
import 'survey-creator-core/i18n/french';
import 'survey-creator-core/i18n/german';
import 'survey-creator-core/i18n/bulgarian';
import 'survey-creator-core/i18n/hungarian';
import 'survey-creator-core/i18n/croatian';
import 'survey-creator-core/i18n/czech';
import 'survey-creator-core/i18n/italian';
import 'survey-creator-core/i18n/korean';
// Runtime Survey translations (Next/Previous buttons, validation messages, etc.)
import 'survey-core/i18n/french';
import 'survey-core/i18n/german';
import 'survey-core/i18n/bulgarian';
import 'survey-core/i18n/hungarian';
import 'survey-core/i18n/croatian';
import 'survey-core/i18n/czech';
import 'survey-core/i18n/italian';
import 'survey-core/i18n/korean';
import { editorLocalization, SurveyCreator } from 'survey-creator-knockout';
import * as SurveyCore from 'survey-core';
import { PageModel, QuestionHtmlModel, setLicenseKey, SurveyModel } from 'survey-core';
import { SurveyCreatorModel, UploadFileEvent } from 'survey-creator-core';
import theme from './theme.creator.js';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { extractError, handleError, initClient } from '../../../../api';
import { blobDownload, formatDateTimeSeconds, WindowType } from '../../../../util';
import { registerCustomPropertiesLocalization } from './customPropsEditor';
import { registerSimpleCustomProperties } from './../../customPropsRegistration';
import CopyModal from './CopyModal';
import ConvertModal from './ConvertModal';
import {
  AiSearchClient,
  ConvertReturn,
  CopyToRequest,
  ISurveyView,
  QuestionGenerationRequest,
  QuestionResponse,
  SurveyJsUiClient,
  SurveyView,
  TranslationApiUiClient,
  TranslationRequest,
} from '../../../backend/backendapi';
import { supportedLangSet } from '../../lang';
import SurveyStore from '../../../../stores/SurveyStore';
import { injectQuillSurveyCreatorInstanceKnockout, injectQuillSurveyCreatorKnockout } from './TabSurvey/QuillInjectorKnockout';
import ContactStore from '../../../../stores/ContactStore';
import {
  applyCustomDropdownChoices,
  hasContactsField,
  registerSurveyCustomDropdownProperties,
  registerSurveyCustomDropdownPropertiesTranslation,
} from '../../customDropdown';
import { applyCustomDownload, registerSurveyCustomDownloadProperties, registerSurveyCustomDownloadPropertiesTranslation } from '../../customDownload';
import { applyCustomImageVideo, registerSurveyCustomImageVideoProperties, registerSurveyCustomImageVideoPropertiesTranslation } from '../../customImageVideo';
import { applyCustomTelValidator } from '../../customTelValidator';
import { paginationOptions, searchOptions } from '../../../../util/vue-good-table';
import AttachmentsButtonIfPresent from '../../AttachmentsButtonIfPresent';
import QuestionGeneratorModal, { registerQuestionGeneratorModalProperties } from './QuestionGeneratorModal';
import Spinner from '../../../util/Spinner';
import { getLocalizedSurveyNameFromSurvey } from '../../utils';

SurveyCore.JsonObject
    .metaData
    .addProperty('question', { name: 'score:number' });


registerSimpleCustomProperties(); 
registerQuestionGeneratorModalProperties();
registerSurveyCustomDropdownProperties();
registerSurveyCustomDownloadProperties();
registerSurveyCustomImageVideoProperties();



declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

//inject quill
injectQuillSurveyCreatorKnockout();

@Component({
  name: 'SurveyJSCreatorComponent',
  components: {
    AttachmentsButtonIfPresent,
    ConvertModal,
    CopyModal,
    VueGoodTable,
    Spinner,
    QuestionGeneratorModal
  },
})
export default class SurveyJSCreatorComponent extends Vue {
  private surveyCreator!: SurveyCreator;

  private readonly store = new SurveyStore();
  private readonly contactStore = new ContactStore();
  private selectedSurvey: SurveyView | null = null;
  private newSurveyName: string | null = null;

  private readonly api = initClient(SurveyJsUiClient);
  private readonly apitrans = initClient(TranslationApiUiClient);
  private readonly apiAi = initClient(AiSearchClient);
  private loading: boolean = false;

  get columnsConfig(): any[] {
    return [
      {
        label: this.$t('name'),
        field: (e: SurveyView) => getLocalizedSurveyNameFromSurvey(e, '?', this.$i18n.locale),
        isSurveyNameColumn: true,
      },
      {
        label: this.$t('surveyActions'),
        field: e => 1, //dummy
        isActions: true,
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  mounted(): void {
    this.store.reload();
    this.contactStore.reload();
    this.setupLocalization();
    const options = {
      showJSONEditorTab: false,
      showTestSurveyTab: true,
      showTranslationTab: true,
      showLogicTab: false,
      showEmbeddedSurveyTab: false,
      showOptions: true,
      clearTranslationsOnSourceTextChange: true,
    };
    this.surveyCreator = new SurveyCreator(options);

    // hook into every survey instance the creator spins up (preview/test tab)
    this.surveyCreator.onSurveyInstanceCreated.add((_, options) => {
      // Force the preview survey instance to use the current app locale
      options.survey.locale = this.$i18n.locale;
      applyCustomDropdownChoices(options.survey, this.contactStore.contacts);
      applyCustomDownload(options.survey, this.$t('general.download').toString());
      applyCustomImageVideo(options.survey);
      applyCustomTelValidator(options.survey);
    });
    this.surveyCreator.saveSurveyFunc = this.save(); //TODO wtf
    //this.surveyCreator.haveCommercialLicense = true; // version lower <1.9.100
    setLicenseKey( // versions > 1.9.100 
        'NjUxNzE0ODktZmVmOS00ZDRkLWE3M2MtZDdlZTI4MGM3ZjcwOzE9MjAyNS0wMS0yOQ==',
    );
    this.surveyCreator.theme = theme;
    this.surveyCreator
        .toolbox
        .getItemByName('image')
        .json
        .imageLink = window.location.protocol + '//' + window.location.host + window.application.baseUrl + 'icons/files/revocheck-button-360px.png';

    this.surveyCreator
        .toolbox
        .getItemByName('imagepicker')
        .json
        .choices = [
      {
        value: 1,
        imageLink: window.location.protocol + '//' + window.location.host + window.application.baseUrl + 'icons/files/revocheck-button-360px.png',
      },
    ];
    injectQuillSurveyCreatorInstanceKnockout(this.surveyCreator);
    // show image link in translation
    this.surveyCreator.onTranslationStringVisibility.add((sender, options) => {
      if (options.propertyName === 'imageLink' &&
          String(options.obj.getPropertyValue('imageLink')).includes('http')) {
        options.visible = true;
      }
    });
    // Enable AI-powered localization
    this.surveyCreator.onMachineTranslate.add((_, options) => {
      let trans = new TranslationRequest();
      trans.toTranslate = options.strings;
      trans.toLocale = options.toLocale;
      trans.fromLocale = options.fromLocale;
      this.apitrans.translate(trans)
          .then(data => {
            //this.surveyCreator.clearTranslationsOnSourceTextChange = false; // TODO needs higher version
            options.callback(data.fromTranslate);
            //this.surveyCreator.clearTranslationsOnSourceTextChange = true;
            const str = data.fromTranslate.length + ' strings are translated';
            this.surveyCreator.notify(str);
          })
          .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
    });

    //file upload
    this.surveyCreator.onUploadFile.add((_: SurveyCreatorModel, options: UploadFileEvent) => {
      if (options.files.length !== 1) {
        return options.callback('error', 'Only 1 file allowed');
      }

      const file = options.files[0];
      this.api.createMedia(this.selectedSurvey?.id!, false, { data: new Blob([file], { type: file.type }), fileName: file.name })
          .then(e => options.callback('success', e.publicUrl))
          .catch(e => options.callback('error', extractError(e)));
    });
    //TODO file delete; atm there is no api available in the survey creator
    this.surveyCreator.render('surveyCreator');

    // TODO survey-creator: "1.12.4"" doesnt support onClick event, so we need to add it manually
    const creatorEl = document.getElementById('surveyCreator');
    if (creatorEl) {
      creatorEl.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (target.matches('[data-action="make-questions"]') || 
          target.closest('[data-action="make-questions"]')) {
          (this.$refs.questionGeneratorModal as QuestionGeneratorModal).openModal();
        }
      });
    }
  }

  private setupLocalization() {
    const currentLang = this.$i18n.locale;
    
    // Set the editor and core locale to your current app language
    SurveyCore.surveyLocalization.defaultLocale = this.$i18n.locale;
    SurveyCore.surveyLocalization.supportedLocales = supportedLangSet;
    
    // Register custom property translations
    registerCustomPropertiesLocalization();
    registerSurveyCustomDropdownPropertiesTranslation();
    registerSurveyCustomDownloadPropertiesTranslation();
    registerSurveyCustomImageVideoPropertiesTranslation();

    // Update current locales
    editorLocalization.currentLocale = currentLang;
    SurveyCore.surveyLocalization.currentLocale = currentLang;

    SurveyCore.surveyLocalization.localeNames['hu'] = 'Hungary';
    SurveyCore.surveyLocalization.localeNames['cs'] = 'Czech';
    SurveyCore.surveyLocalization.localeNames['sl'] = 'Slovenian';
    SurveyCore.surveyLocalization.localeNames['sk'] = 'Slovak'; // fix language issue, see https://github.com/surveyjs/survey-library/commit/5f6f7337a385b2e71080e52a097ce0cdeea1299c
    SurveyCore.surveyLocalization.localeNames['de'] = 'German';
    SurveyCore.surveyLocalization.localeNames['en'] = 'English';
    SurveyCore.surveyLocalization.localeNames['pl'] = 'Poland';
    SurveyCore.surveyLocalization.localeNames['tr'] = 'Turkey';
    SurveyCore.surveyLocalization.localeNames['ro'] = 'Romania';
    SurveyCore.surveyLocalization.localeNames['it'] = 'Italy';
    SurveyCore.surveyLocalization.localeNames['es'] = 'Spain';
    SurveyCore.surveyLocalization.localeNames['rs'] = 'Serbia';
    SurveyCore.surveyLocalization.localeNames['lt'] = 'Lithuania';
    SurveyCore.surveyLocalization.localeNames['lv'] = 'Latvia';
    SurveyCore.surveyLocalization.localeNames['pt'] = 'Portugal';
    SurveyCore.surveyLocalization.localeNames['hr'] = 'Croatia';
    SurveyCore.surveyLocalization.localeNames['uk'] = 'Ukraine';
    SurveyCore.surveyLocalization.localeNames['ko'] = 'Korean';
    SurveyCore.surveyLocalization.localeNames['fr'] = 'French';
    SurveyCore.surveyLocalization.localeNames['bg'] = 'Bulgarian';
    SurveyCore.surveyLocalization.localeNames['mk'] = 'Macedonian';
  }
    
  private load(json: string): void {
    this.surveyCreator.text = json;
  }

  newSurvey(): void {
    this.selectedSurvey = new SurveyView({
      name: this.newSurveyName,
      json: '{"title": "' + this.newSurveyName + '","pages": [ {"name": "page1" }] }',
    } as ISurveyView);
    this.load(this.selectedSurvey.json);
    this.newSurveyName = null;

    this.save(); //save immediately so media can be uploaded
  }

  private save(): void {
    const json = this.surveyCreator.text;

    if (!this.selectedSurvey) {
      return;
    }

    this.selectedSurvey.json = json;
    let title = JSON.parse(json).title;
    if (typeof title === 'object') {
      title = title.default;
    }
    this.selectedSurvey.name = title;
    this.selectedSurvey.score = (JSON.parse(json).pages as any[] || []).map(p => (p.elements as any[] || []).map(e => e.score ?? 0).reduce((l, r) => l + r, 0)).reduce((l, r) => l + r, 0);
    console.log('fs', this.selectedSurvey.score);
    const validForDays = JSON.parse(json).customValidForDays;
    this.selectedSurvey.validForSeconds = !validForDays ? undefined : validForDays * 86400;
    this.selectedSurvey.hasContacts = hasContactsField(json);

    if (!this.selectedSurvey!.id) {
      this.api.create(this.selectedSurvey)
          .then(survey => {
            Object.assign(this.selectedSurvey!, survey);
            this.store.rememberSurvey(this.selectedSurvey!);
            this.$toasted.info(this.$t('txtSaved').toString());
          })
          .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
    } else {
      this.api.update(this.selectedSurvey)
          .then(survey => {
            this.$toasted.info(this.$t('txtSaved').toString());
          })
          .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
    }
  }

  backToList(): void {
    if (!this.selectedSurvey) {
      return;
    }

    const json = this.surveyCreator.text;
    if (json !== this.selectedSurvey.json) {
      if (!confirm(this.$t('surveyConfirmNotSaveDiscard').toString())) {
        return;
      }
    }

    this.selectedSurvey = null;
  }

  //
  takeSurvey(survey: SurveyView): void {
    window.location.href = this.url(survey);
  }

  copySurveyUrl(survey: SurveyView): void {
    navigator.clipboard.writeText(this.url(survey));
    this.$toasted.info(this.$t('txtCopiedToClipboard').toString());
  }

  getQr(survey: SurveyView): void {
    this.api.getQrCode(survey.id)
        .then(_ => {
          blobDownload(_.data, _.fileName ?? ('survey' + '_' + formatDateTimeSeconds(new Date()) + '.pdf'));
          this.$toasted.info(this.$t('txtDone').toString());
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  goToResults(survey: SurveyView): void {
    window.location.href = this.url(survey) + '/results';
  }

  editSurvey(survey: SurveyView): void {
    this.selectedSurvey = survey;
    this.load(this.selectedSurvey.json);
  }

  copySurvey(survey: SurveyView): void {
    let copy = new SurveyView(survey);
    let num = this.store.surveys
        .filter(e => e.name.startsWith(copy.name))
        .map(e => e.name.substring(copy.name.length).trim())
        .filter(e => e.match('[0-9]+'))
        .map(e => parseInt(e))
        .reduce((l, r) => Math.max(l, r), 1) + 1;
    copy.name += ' ' + num;
    this.api.create(copy)
        .then(res => {
          this.store.rememberSurvey(res);
          this.$toasted.info(this.$t('txtCopied').toString());
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  deleteSurvey(survey: SurveyView): void {
    if (!confirm(this.$t('surveyConfirmDelete').toString())) {
      return;
    }

    this.api.delete(survey.id)
        .then(_ => {
          this.store.forgetSurvey(survey);
          this.$toasted.info(this.$t('txtDeleted').toString());
        })
        .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
  }

  deleteResultsOfSurvey(survey: SurveyView): void {
    if (!confirm(this.$t('surveyResultsConfirmDelete').toString())) {
      return;
    }

    this.api.deleteResultOfSurvey(survey.id)
        .then(_ => {
          this.$toasted.info(this.$t('txtDeleted').toString());
        })
        .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
  }

  url(survey: SurveyView): string {
    return window.location.protocol + '//'
        + window.location.hostname
        + (window.location.port?.length ? ':' + window.location.port : '')
        + window.application.baseUrl
        + 'survey/' + survey.id;
  }

  onCopySurvey(event: { survey: SurveyView, name: string, shared: boolean, sharedWithAccounts: number[] }): void {
    if (event.survey !== undefined && event.sharedWithAccounts.length > 0) {
      let req = new CopyToRequest();
      req.name = event.name;
      req.accountIds = event.sharedWithAccounts;
      req.id = event.survey.id;
      this.api.copyTo(req)
          .then(_ => {
            this.store.reload(true);
            this.$toasted.info(this.$t('txtCopied').toString());
          })
          .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
    }
    (this.$refs.copyModal as CopyModal).closeModal();
  }

  openCopyTo(survey: SurveyView) {
    (this.$refs.copyModal as CopyModal).openModal(survey);
  }

  get canSeeResults(): boolean {
    return window.application.permissions.survey.approval || window.application.permissions.survey.admin;
  }

  get canSeeEdit(): boolean {
    return window.application.permissions.survey.admin;
  }

  openImportModal(): void {
    (this.$refs.convertModal as ConvertModal).open();
  }

  importedDone(e: ConvertReturn): void {
    let ret = e;
    (this.$refs.convertModal as ConvertModal).dismiss();

    this.selectedSurvey = new SurveyView({ name: this.newSurveyName, json: this.makeModel(this.newSurveyName, ret) } as ISurveyView);
    this.load(this.selectedSurvey.json);
    this.newSurveyName = null;
  }

  makeModel(title: string | null, pages: ConvertReturn) {
    let m: SurveyModel = new SurveyModel();

    for (let item of pages.pages) {
      let x: QuestionHtmlModel = new QuestionHtmlModel(item.name);
      x.html = item.htmlContent;
      x.title = item.name;
      x.customWasImported = true;

      let p: PageModel = new PageModel(item.name);
      p.addElement(x);
      p.title = item.name;
      m.addPage(p);
    }

    m.title = pages.name;
    return JSON.stringify(m);
  }

  onGenerateQuestions(count: number): void {
    const json = JSON.parse(this.surveyCreator.text);

    const htmlElements: any[] = [];
    for (const page of json.pages || []) {
      for (const element of page.elements || []) {
        if (element.type === 'html') {
          htmlElements.push(element);
        }
      }
    }
    this.loading=true;

    const extractedDocuments: string[] = htmlElements
    .map(item => {
      if (!item.html) return '';
      
      // If html is already a plain string, use it
      if (typeof item.html === 'string') {
        return item.html;
      }
      
      // Otherwise, look for 'en' first, then 'default'
      return item.html.en || item.html.de || item.html.default || '';
    })
    .filter(htmlString => {
      const trimmed = htmlString.trim();
      if (trimmed === '') return false;
  
      // Skip large HTML documents that contain heavy SVGs or PDF wrappers
      if (trimmed.includes('<svg') || trimmed.includes('pdf-page')) {
        this.$toasted.error('Skipping HTML element containing a heavy SVG/PDF layout.');
        return false;
      }
    return true;
  });

    this.apiAi.getQuestions(new QuestionGenerationRequest(new QuestionGenerationRequest({ 
      documents: extractedDocuments,
      questionsPerChunk: count
    })))
      .then((response: QuestionResponse) => {
        console.log('Generated questions:', response.questions);
        this.addYesNoQuestionsToSurvey(response);
        this.loading=false;
      })
      .catch((error: any) => {
        console.error('Error generating questions:', error);
        this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(error));
        this.loading=false;
      });
  }

  addYesNoQuestionsToSurvey(response: QuestionResponse): void {
     const currentJson = JSON.parse(this.surveyCreator.text);

     if (!currentJson.pages || currentJson.pages.length === 0) {
       currentJson.pages = [{ name: 'page1', elements: [] }];
     }

     const targetPage = currentJson.pages[0];
     targetPage.elements = targetPage.elements || [];

     for (const question of response.questions) {
       targetPage.elements.push({
         type: 'boolean',
         name: `yesno_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, // More unique name
         title: question,
         labelTrue: 'Yes',
         labelFalse: 'No',
       });
     }

     // Set the modified JSON back as a string
     this.surveyCreator.text = JSON.stringify(currentJson, null, 2);
  }
}
